<template>
  <bs-modal
    name="end-session"
    :ok-title="$t('javascript.i_am_done')"
    :cancel-title="$t('javascript.cancel')"
    :ok-tooltip="$t('javascript.a_new_session_will_begin')"
    @ok="okClicked"
    @cancel="$emit('cancel')"
    :value="value"
    @input="$emit('input', $event)"
  >
    <form v-if="adc && adcBeforeFinal">
      <h2> {{ $t('javascript.automatic_dealcloser') }} </h2>
      <p class="bold">
        {{ $t('javascript.if_small_gap_remains_2') }}
      </p>

      <div class="form-inline">
        <div class="form-group" >
          <label class="control-label" for="secret-ext">{{ $t('javascript.i_will_move_closer') }}:</label>
          <div class="input-group">
            <input class="form-control" id="secret-ext" type="number" @input="handleADC" :placeholder="adcSecretExtension" v-model="secretExtension" min="0" step="1" style="width: 120px;">
            <div class="input-group-addon">{{ adcUnit }}</div>
          </div>
        </div>
      </div>
      </br>
      <div class="form-inline">
        <p class="alert-danger" v-if="(agreeToUseAdc === 'true') && ((secretExtension < '0') || secretExtension > (adcSecretExtension * 10) )">
          {{ $t('javascript.please_specify_value', {maxAdc}) }}
        </p>
      </div>
      <div class="form-inline">
        <p class="alert-danger" v-if="(agreeToUseAdc === 'true') && ((secretExtension === null) || (secretExtension === '0'))">
          {{ $t('javascript.please_fill_in') }}
        </p>
      </div>
    </form>
    <form v-else>
      <h2> {{ otherPartyEndedSession ? $t('javascript.check_agreement') : $t('javascript.end_current_session', {sessionNumber}) }} </h2>
    </form>

  </bs-modal>
</template>

<script>
  import BsModal from './bs_modal'

  export default {
    name: "end-session-modal",
    props: {
      value: {
        type: Boolean,
        default: false
      },
      adc: {
        type: Boolean,
        default: false
      },
      adcBeforeFinal: {
        type: Boolean,
        default: false
      },
      adcSecretExtension: {
        type: Number,
        default: 0
      },
      adcUnit: {  // formats and units
        type: String,
        default: 'CAD'
      },
      sessionNumber: {
        type: Number,
        default: 1
      },
      otherPartyEndedSession: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        agreeToUseAdc: 'true',
        secretExtension: 0
      }
    },
    components: {BsModal},
    methods: {
      okClicked() {
        let extension = 0
        if (this.agreeToUseAdc === 'true')
          extension = this.secretExtension
        this.$emit('ok', {extension})
      }, handleADC(){
        this.agreeToUseAdc = 'true';
      }, 
    },
    computed: {
      maxAdc(){
        return this.adcSecretExtension * 10
      }
    },
    created() {
      this.secretExtension = this.adcSecretExtension
    }
  }
</script>
